const measurementId = import.meta.env.VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY as string | undefined;

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export function initAnalytics() {
  if (!measurementId) return;

  // Queue page views immediately, but load the tag only once the browser is
  // idle so it doesn't compete with rendering the page.
  window.dataLayer = window.dataLayer || [];
  const gtag = (...args: unknown[]) => window.dataLayer.push(args);
  gtag("js", new Date());
  gtag("config", measurementId);

  const load = () => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  };

  const schedule = () => {
    if (typeof requestIdleCallback === "function") requestIdleCallback(load, { timeout: 4000 });
    else setTimeout(load, 2000);
  };

  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
}

export function trackPageView(path: string) {
  if (!measurementId || !window.dataLayer) return;
  window.dataLayer.push(["event", "page_view", { page_path: path }]);
}
